export default lists => {

  const actuallocale = window.academystatus.locale.replace('_', '-')

  return `
  <div id="QuickRegistry">
    <div class="Overlay"></div>
    <div class="QuickRegistry">
      <div class="QuickRegistryForm">
        <div class="Presentation">${ __('quickregister_presentation') }</div>
        <form>
          <div class="Field">
            <input name="email" type="email" placeholder="${ __('Email address') }"/>
          </div>
          <div class="Field">
            <select name="language">
              <option value="">${ __('Select language') }</option>
              ${ 
                Object.keys(lists.languages)
                .map(
                  key => '<option value="' + 
                        key + 
                        '"' +
                        (lists.languages[key].locale == actuallocale ? ' selected="selected"' : '') +
                        '>' +
                        lists.languages[key].name +
                        '</option>'
                )
                .join('')
              }
            </select>
          </div>
          <div class="Field">
            <select name="country">
              <option value="">${ __('Select country') }</option>
              ${ 
                Object.keys(lists.countries)
                .map(
                  key => '<option value="' + 
                        key + 
                        '">' +
                        lists.countries[key] +
                        '</option>'
                )
                .join('')
              }
            </select>
          </div>
        </form>
        <div class="FormResults">
        </div>
        <div class="Submit">
          ${ __('Submit') }
        </div>
      </div>
      <div class="Close"></div>
    </div>
  </div>
  `
}